import PasswordResetForm from '@/components/PasswordResetForm';

interface Props {
    token: string;
}

export default function Edit({ token }: Props) {
    return (
        <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
            <div className="w-full max-w-sm">
                <PasswordResetForm token={token} />
            </div>
        </div>
    );
}